module.exports = __webpack_public_path__ + "img/beijing-1.53d84e63.jpg";